import "./styles.css";
import icLoading from "../../assets/loading.svg";

const Loading: React.FC<{}> = () => {
  return (
    <div className="loading-box">
      <img src={icLoading} className="img-loading" alt="loading" />
    </div>
  );
};

export default Loading;
